var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-like"},[_c('user-link',{attrs:{"user":_vm.source}}),_vm._v(" "+_vm._s(_vm.likeIcon)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }